import React from 'react';
import { Row as AntRow } from 'antd';
import { RowProps } from 'antd/lib/row';

const Row: React.FC<RowProps> = (props) => <AntRow {...props} />;

export default Row;
